import $ from 'jquery';
import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { getFieldValueFromGridData, formatBid } from '@bingads-webui-campaign/recommendation-core';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import InlineBudgetEditor from '@bingads-webui-campaign-legacy/budget/view/inline-budget-editor';

class CustomizedInlineBudgetEditor extends InlineBudgetEditor {
  initialize({
    item, $elToBlock, isForVNext, permissions, currencySymbol, clientName, perfMarker, key, view,
  }) {
    this.key = key;
    this.view = view;
    super.initialize({
      item,
      $elToBlock,
      isForVNext,
      permissions,
      currencySymbol,
      clientName,
      perfMarker,
    });
  }

  save() {
    if (!this.viewModel.isValid()) {
      return;
    }

    const { view, key } = this;
    const recommendation = view.grid.gridView.itemWithKey(key);

    if (!_.isNull(recommendation)) {
      const updatedBudget = _.defaults(this.viewModel.toObject(), this.item.Budget);
      if (this.viewModel.Amount.isValid()) {
        _.first(recommendation.Opportunities).NewBudget = updatedBudget.Amount;
      }
      // Append the current selected one into existing selected ones.
      const selectedKeys = view.grid.gridView.selectedKeys();
      if (!_.contains(selectedKeys, key)) {
        selectedKeys.push(key);
      }
      view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
    }

    this.remove();
  }
}

export class CampaignBudgetColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, newI18n, view, deps,
  }) {
    const title = newI18n.getString(_TL_('Suggested campaign budget'));
    super({
      name: 'CampaignBudget',
      property: 'Opportunities/CampaignBudget',
      title,
      bodyClasses: ['grid-column-campaignBudget'],
      colClasses: ['col-shortNumber'],
      sortable: false,
      editable: true,
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.currency = this.i18n.currency;
    this.permissions = deps.permissions;
    this.view = view;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const { i18n, currency } = this;
    _.first(Opportunities).SuggestedBudget = getFieldValueFromGridData(_.chain(Opportunities).first().result('GridData').value(), 'Budget');
    const suggestedBudgetValue = _.chain(Opportunities).first().result('SuggestedBudget').value();
    return formatBid(_.chain(Opportunities).first().result('NewBudget').value() || suggestedBudgetValue, i18n, currency);
  }

  get property() {
    return {
      get: _.identity,
      key: 'CampaignBudget',
    };
  }

  onPrompt({
    event, item, newPosition,
  }) {
    const Budget = { Budget: { Amount: _.chain(item.Opportunities).first().result('NewBudget').value() || _.chain(item.Opportunities).first().result('SuggestedBudget').value(), Type: 'DailyStandard' } };
    _.extend(item, Budget, { Id: -1, CampaignType: 'Shopping' });
    const key = $(event.target).parents('tr[data-key]').data('key');
    const editor = new CustomizedInlineBudgetEditor({
      item,
      $elToBlock: this.view.grid.gridView.$el,
      isForVNext: true,
      permissions: this.permissions,
      currencySymbol: this.i18n.getCurrencySymbol(),
      clientName: 'CampaignTabEditing',
      perfMarker: null,
      key,
      view: this.view,
    });

    const editorView = new GridCustomizedPopupEditor({
      editorView: editor.render(),
      cellPosition: newPosition,
      renderBelow: false,
      className: 'grid-popupeditor grid-group-other inline-budget-editor-popup',
      parentContainerSelector: '.grid-and-disclaim-container',
    });

    editorView.render();
    return editorView;
  }
}
